// File: AnnualCompliance.jsx
import React from "react";

export default function AnnualCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Annual Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks ensures complete annual compliance under the Companies Act.
          </p>
          <p className="text-gray-700">
            Full annual compliance services including financial statements, ROC filings, auditor coordination, board resolutions, statutory registers, and Companies Act 2013 requirements for Private Limited Companies.
          </p>
        </div>

        {/* Right: Image (ANNUAL COMPLIANCE SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Annual compliance services for Private Limited Companies by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless ROC annual compliance filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements (Balance Sheet, P&L)</li>
                <li>ROC annual forms (AOC-4, MGT-7)</li>
                <li>Auditor reports and certificates</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Corporate law expertise ensuring accurate filings and complete Companies Act compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Corporate Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Companies Act 2013 requirements including AOC-4 (financials), MGT-7 (annual return), MGT-14 (board resolutions), ADT-1 (auditor appointment), statutory registers, board meetings, and ROC compliance calendar.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate ROC Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise MCA portal submissions, e-form validations, auditor coordination, DIR-3 KYC compliance, DSC renewals, annual return certifications, penalty avoidance, and first-time ROC approvals with zero discrepancies.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service annual compliance from financial statement preparation through auditor appointments, board meeting documentation, ROC form filings, statutory register maintenance, compliance audits, and ongoing advisory support.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
